import { observer } from 'mobx-react-lite'
import { useRootStore } from 'mobx-stores/store-provider'
import { useEffect } from 'react'
import { useParams } from 'react-router'
import { ProductsStoreAddNewProduct } from '../products-add-new-product'

const ProductsEditProductComponent = () => {

    const { productId, storeId } = useParams<{ productId: string; storeId?: string }>(),
    {
        viewProductsPageStore: {
            getProductById,
            setProductId
        },
        userStore: { setManagementStoreId }
    } = useRootStore()

    setProductId(productId);

    useEffect(() => {
        setManagementStoreId(storeId)
    }, [storeId, setManagementStoreId])

    useEffect(() => {
        if (productId) {
            getProductById(productId);
        }
    }, [productId, getProductById])

  return (
    <ProductsStoreAddNewProduct editMode productId={productId} />
  )
}

const ProductsEditProduct = observer(ProductsEditProductComponent)
export { ProductsEditProduct }
